export default __webpack_public_path__ + "static/media/logo.eb8e1f75.svg";